
import React from "react";
import PageHeader from "../../components/PageHeader";
import CategoryUpdateComponent from "../../components/Category/CategoryUpdate";

class CategoryUpdate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Category Update"
                            Breadcrumb={[
                                { name: "Categories", navigate: "/categories" },
                                { name: "Category Update", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <CategoryUpdateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CategoryUpdate;
